// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import type { InlineRichText } from '../../internal/types';
import FormattedContent from '../../internal/FormattedContent';
import ButtonCta, { type CtaButtonType } from './Internal/ButtonCta';

const blockVariantMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
};

type PropTypes = {|
  background: 'Low' | 'Medium' | 'High' | 'Dark',

  title: string,
  children: InlineRichText,

  firstCtaBtn: CtaButtonType,
  secondCtaBtn?: CtaButtonType,
|};

const CtaText = (props: PropTypes) => {
  return (
    <PageContentBlock background={blockVariantMap[props.background]} layout="Thin">
      <div className={styles.ctaText}>
        {props.title && <h2 className={styles.title}>{props.title}</h2>}
        {props.children && (
          <FormattedContent isDarkBackground={props.background === 'Dark'} className={styles.intro}>
            {props.children}
          </FormattedContent>
        )}
        {props.secondCtaBtn ? (
          <div>
            <ButtonCta
              {...props.firstCtaBtn}
              className={styles.ctaBtn}
              background={props.background}
            />
            {/* $FlowFixMe */}
            <ButtonCta
              {...props.secondCtaBtn}
              className={styles.ctaBtn}
              background={props.background}
            />
          </div>
        ) : (
          <ButtonCta {...props.firstCtaBtn} background={props.background} />
        )}
      </div>
    </PageContentBlock>
  );
};

CtaText.defaultProps = {
  background: 'Medium',
};

export default CtaText;
